<script setup>
import HeaderComponent from "@/components/HeaderComponent.vue";
import { RouterView } from "vue-router";
import { useContextStore } from "@/stores/context";

const context = useContextStore();

</script>

<template>
  <div :class="context.isDarkMode ? 'bg-void' : 'bg-white'">
    <HeaderComponent />

    <section>
      <RouterView />
    </section>
  </div>
</template>
